<template>
  <div class="warning-option" style="text-align: center;margin: 100px auto;">
    <i>&nbsp;</i>
    <span
      style="font: 600 16px/48px microsoft yahei;vertical-align: middle;letter-spacing: normal;word-spacing: normal;display: inline-block;">暂无符合条件的数据记录</span>
  </div>
</template>

<script>
  export default {
    name: 'NoRecord',
    data() {
      return {

      }
    }
  }
</script>
